module.exports = {"0":"No Discount","1":"Net 30","3":"1/2% 20 Days","6":"1/2% 10 Days","8":"1/4% 20 Days","10":"2% 10 Days"}


//////////////////
// WEBPACK FOOTER
// ./src/pages/DibbsRfq/optionsJson/discountCodes.json
// module id = 5240
// module chunks = 1